var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('b-container',[_c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('b-col',[_c('h1',[_vm._v("No access rights"),_c('br'),_vm._v("Please contact administrator")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }